import * as types from "./actionTypes";

export const holidaySetIsLoading = (isLoading) => ({
  type: types.HOLIDAY_SET_IS_LOADING,
  payload: isLoading,
});

export const holidaySetData = ({ holidayData }) => ({
  type: types.HOLIDAY_SET_DATA,
  payload: { holidayData },
});

export const holidayHistorySetData = ({ holidayHistoryData }) => ({
  type: types.HOLIDAY_HISTORY_SET_DATA,
  payload: { holidayHistoryData },
});

export const holidayRequestData = () => ({
  type: types.HOLIDAY_REQUEST_DATA,
});

export const postHolidayRequestForm = (formContent) => ({
  type: types.POST_HOLIDAY_REQUEST_FORM,
  payload: { formContent },
});

export const setHolidayRequestFormLoading = (isLoading) => ({
  type: types.SET_HOLIDAY_REQUEST_FORM_LOADING,
  payload: isLoading,
});

export const setHolidayRequestFormSubmitted = (status) => ({
  type: types.SET_HOLIDAY_REQUEST_FORM_SUBMITTED,
  payload: status,
});
